export const UPDATE_WIRE_CURRENT_STEP_INDEX = "UPDATE_WIRE_CURRENT_STEP_INDEX";
export const UPDATE_CARD_CURRENT_STEP_INDEX = "UPDATE_CARD_CURRENT_STEP_INDEX";
export const SET_WIRE_BANK_DETAIL = "SET_WIRE_BANK_DETAIL";
export const UPDATE_WIRE_CURRENCY = "UPDATE_WIRE_CURRENCY";
export const UPDATE_CARD_INFO = "UPDATE_CARD_INFO";
export const UPDATE_CARD_ADDREES_ID = "UPDATE_CARD_ADDREES_ID";
export const UPDATE_BANK_TRANSFER_STEP_INDEX =
  "UPDATE_BANK_TRANSFER_STEP_INDEX";
